module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isPrivacyShown === '0' && _vm.userName) ? _c('PrivacyModal') : _vm._e(), _c('NavBar', [(_vm.unionLoginFailed) ? _c('UnionLoginFailed') : (_vm.userName != '') ? _c('router-view') : (_vm.userName == '') ? _c('IndexPage') : _vm._e()], 1), (_vm.isntFenxiUser) ? _c('CodeTipModal', {
    attrs: {
      "type": _vm.usrType,
      "time": _vm.time,
      "defaulttime": _vm.defaulttime
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-991e3836", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-991e3836!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main.vue
// module id = 783
// module chunks = 0